export const properties = [
    {
        _id: 'sajdf023j',
        title: 'house for rental',
        image: 'house.jpeg',
        price: 1800,
        address: '71-31 Ingram Street, New York, NY 11375',
        day: 1,
        coordinates:{ lat: 40.714446566151196, lng: -73.84700071850583 },
        property_type: 'house',
        rental_type: 'Long Term Rental',
        bedrooms: 1,
        bathrooms: 1,
        kitchen: 0,
        images: ['/images/p-1.jpg','/images/p-2.jpg','/images/p-3.jpg','/images/p-4.jpg','/images/p-5.jpg','/images/p-6.jpg']
    },
    {
        _id: '123jksajdl',
        title: 'house for rental',
        image: 'house.jpeg',
        price: 1800,
        address: '90-19 70th Drive, New York, NY 11375',
        day: 1,
        coordinates:{ lat: 40.70937192071371, lng: -73.8522363905029 },
        property_type: 'house',
        rental_type: 'Long Term Rental',
        bedrooms: 1,
        bathrooms: 1,
        kitchen: 0,
        images: ['/images/p-2.jpg','/images/p-1.jpg','/images/p-3.jpg','/images/p-4.jpg','/images/p-5.jpg','/images/p-6.jpg']
    },
    {
        _id: 'ougdf213',
        title: 'house for rental',
        image: 'house.jpeg',
        price: 1300,
        address: '69-30 Loubet Street, New York, NY 11375',
        day: 1,
        coordinates:{ lat: 40.71373093445085, lng: -73.85288012066647 },
        property_type: 'house',
        rental_type: 'Long Term Rental',
        bedrooms: 1,
        bathrooms: 1,
        kitchen: 0,
        images: ['/images/p-3.jpg','/images/p-5.jpg','/images/p-2.jpg','/images/p-4.jpg','/images/p-5.jpg','/images/p-6.jpg']
    },
    {
        _id: 'asdfhui123',
        title: 'house for rental',
        image: 'house.jpeg',
        price: 1600,
        address: '69-24 49th Avenue, New York, NY 11377',
        day: 2,
        coordinates:{ lat: 40.737212649492704, lng: -73.8950659040527 },
        property_type: 'house',
        rental_type: 'Long Term Rental',
        bedrooms: 1,
        bathrooms: 1,
        kitchen: 0,
        images: ['/images/p-6.jpg','/images/p-2.jpg','/images/p-3.jpg','/images/p-4.jpg','/images/p-5.jpg','/images/p-1.jpg']
    },
    {
        _id: 'owiensdkf',
        title: 'house for rental',
        image: 'house.jpeg',
        price: 1800,
        address: '109 wilton St, New Hyde Park, NY 11040',
        day: 2,
        coordinates:{ lat: 40.7379912, lng: -73.6869879 },
        property_type: 'house',
        rental_type: 'Long Term Rental',
        bedrooms: 1,
        bathrooms: 1,
        kitchen: 0,
        images: ['/images/p-5.jpg','/images/p-1.jpg','/images/p-2.jpg','/images/p-4.jpg','/images/p-3.jpg','/images/p-6.jpg']
    }
]